import { render, staticRenderFns } from "./AlertListAuth.vue?vue&type=template&id=bfe4fc2a"
import script from "./AlertListAuth.vue?vue&type=script&lang=js"
export * from "./AlertListAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports